function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 1.05A5.942 5.942 0 0113.95 8 5.942 5.942 0 018 13.95 5.942 5.942 0 012.05 8 5.942 5.942 0 018 2.05zm-.183 1.742a.526.526 0 00-.517.533v4.2c0 .29.235.525.525.525h2.8a.524.524 0 100-1.05H8.35V4.325a.526.526 0 00-.534-.533z",
  fill: "#595351",
  fillRule: "evenodd"
});

function SvgClockinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgClockinline;